document.addEventListener('DOMContentLoaded', function() {
    // Check for the existence of '#banner-wrapper'
    const bannerWrapper = document.querySelector('#banner-wrapper');
    if (!bannerWrapper) return; // Exit the script if '#banner-wrapper' doesn't exist

    // Get the 'banner-main_header' element and its children
    const bannerMainHeader = document.querySelector('.banner-main_header');
    const childrenOfBannerMainHeader = Array.from(bannerMainHeader.childNodes);

    // Create a new div with the class 'banner-main_header' to wrap the children
    const newDiv = document.createElement('div');
    newDiv.classList.add('banner-main_header');

    // Move all children to the new div
    childrenOfBannerMainHeader.forEach(child => {
        newDiv.appendChild(child);
    });

    // Append the new div to the original 'banner-main_header' element
    bannerMainHeader.appendChild(newDiv);

    // Get the 'banner-logo' div
    const bannerLogo = document.querySelector('.banner-logo');

    // Insert the 'banner-logo' div into the 'banner-main_header' before the newly created div
    bannerMainHeader.insertBefore(bannerLogo, newDiv);
});
